import React, { useContext } from 'react';
import { SolutionCardProps } from './types/SolutionsSection.types';
import {
  HeaderWrapper,
  SolutionCardWrapper,
  MediaImageWrapper,
  ContentWrapper,
  ImageOverlay,
  ButtonRowWrapper,
} from './styles/SolutionsSection.styles';
import RichTextElement from '../pageBuilder/Elements/RichText';
import { DirectionContext } from '../../contexts/DirectionContext';
import {
  SaveIconWrapper,
  TagPillWrapper,
} from '../pageBuilder/Elements/ArticleCard/styles/ArticleCard.styles';
import ArticleCardThumbnail from '../pageBuilder/Elements/ArticleCard/ArticleCardThumbnail';
import CtaButtonRow from '../pageBuilder/Elements/CtaButtons';
import Pill from '@legacy-vfuk/core-pill';
// import SaveArticleIcon from '../SaveArticleIcon/SaveArticleIcon';

const SolutionCard = ({
  id,
  topicName,
  header,
  summary,
  image,
  buttonRow,
}: // displaySaveIcon,
// saveLabelText,
// saveIconClicked,
SolutionCardProps) => {
  const direction = useContext(DirectionContext);

  return (
    <SolutionCardWrapper direction={direction} id={id}>
      <MediaImageWrapper>
        <TagPillWrapper>
          <Pill text={topicName} appearance={'alt2'} key={topicName} />
        </TagPillWrapper>
        <SaveIconWrapper>
          {/* <SaveArticleIcon
            onArticle={false}
            handleSaveClick={() => console.log('slug')}
            show={displaySaveIcon}
            saveLabel={saveLabelText}
          /> */}
        </SaveIconWrapper>
        <ArticleCardThumbnail image={image} />
        <ImageOverlay />
      </MediaImageWrapper>
      <ContentWrapper>
        <HeaderWrapper>{header}</HeaderWrapper>
        <div className="summary">
          <RichTextElement {...summary} />
        </div>
        <ButtonRowWrapper>
          <CtaButtonRow
            key={buttonRow.id}
            buttonRowAlignment={buttonRow.buttonRowAlignment}
            isMobileViewButtonOrderReversed={
              buttonRow.isMobileViewButtonOrderReversed
            }
            buttons={buttonRow.buttons}
            spacing={5}
          />
        </ButtonRowWrapper>
      </ContentWrapper>
    </SolutionCardWrapper>
  );
};

export default SolutionCard;
